import { render, staticRenderFns } from "./shanxiStudentList.vue?vue&type=template&id=0caeec10&scoped=true"
import script from "./shanxiStudentList.vue?vue&type=script&lang=js"
export * from "./shanxiStudentList.vue?vue&type=script&lang=js"
import style0 from "./shanxiStudentList.vue?vue&type=style&index=0&id=0caeec10&prod&lang=less"
import style1 from "./shanxiStudentList.vue?vue&type=style&index=1&id=0caeec10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caeec10",
  null
  
)

export default component.exports